export const PAGES = {
  ACCOUNT: 'Account',
  GENERAL: 'General',
  BILLING: 'Billing',
  SECURITY: 'Security',
  COMPANY: 'Company',
  ACCESS_TOKENS: 'Personal access tokens',
  USAGE: 'Usage',
  TEAM: 'Teammates',
  MEMBERS: 'Members',
  DATA_PRIVACY: 'Data Privacy',
  AUDIT_LOGS: 'Audit Logs',
};
export const EVENT_TYPES = {
  CloudExtract: 'CloudExtract',
  WarehouseAction: 'WarehouseAction',
  EventStream: 'EventStream',
};

export const EVENT_TYPE_LABELS = {
  [EVENT_TYPES.EventStream]: 'Event Stream',
  [EVENT_TYPES.CloudExtract]: 'Cloud Extract',
  [EVENT_TYPES.WarehouseAction]: 'Reverse ETL',
};
